import PropTypes from 'prop-types';
export default {
  propType: PropTypes.shape({
    paddingBottom: PropTypes.number,
    paddingLeft: PropTypes.number,
    paddingRight: PropTypes.number,
    paddingTop: PropTypes.number
  })
};